const goToTeam = (team) => {

  window.location = `/app/teams/${team.slug}`
  
}

export default goToTeam
